<script setup>

import ReviewsSummary from "@/Components/Product/ReviewsSummary.vue";

import { parseDate } from "@/utility";

const props = defineProps({
  reviews : {
    type: Array,
    required: false,
    default: []
  }
})

function uniqueHexColorFromNickname(nickname) {
  // Generate a hash code from the nickname
  let hash = 0;
  for (let i = 0; i < nickname.length; i++) {
    hash = nickname.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert the hash code to a hexadecimal color code
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF; // Extract 8 bits
    color += ('00' + value.toString(16)).slice(-2); // Convert to hexadecimal and pad with zeros
  }

  // Ensure the color is not too light
  const brightnessThreshold = 128; // Adjust this threshold as needed
  const rgb = parseInt(color.substring(1), 16); // Convert hex color to RGB
  const r = (rgb >> 16) & 0xFF;
  const g = (rgb >> 8) & 0xFF;
  const b = rgb & 0xFF;
  const brightness = (r * 299 + g * 587 + b * 114) / 1000; // Calculate brightness (perceived luminance)
  if (brightness > brightnessThreshold) {
    // If color is too light, make it darker
    const darkenAmount = brightness - brightnessThreshold;
    color = adjustColor(color, -darkenAmount);
  }

  return color;
}

// Function to adjust the brightness of a color
function adjustColor(color, amount) {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const subtractLight = (color, amount) => Math.round(clamp(parseInt(color, 16) - amount, 0, 255));
  const darken = (color) => ('0' + subtractLight(color.substr(1, 2), amount).toString(16)).slice(-2) +
    ('0' + subtractLight(color.substr(3, 2), amount).toString(16)).slice(-2) +
    ('0' + subtractLight(color.substr(5, 2), amount).toString(16)).slice(-2);
  return darken(color);
}

</script>

<template>

  <div id="reviews" class="col-12 col-lg-6 reviews-container" v-if="reviews.length">

    <div class="header mb-4">
      <span class="title user-select-none">{{__('reviews')}}</span>
    </div>

    <div class="reviews">
      <div class="review d-flex gap-2 pb-3 mb-3 mt-3 border-bottom-1" v-for="review in props.reviews">
        <div class="reviewer px-4 py-0 d-flex flex-column justify-content-center align-items-center">
          <div class="avatar mb-2 text-white" :style="'background-color:' + uniqueHexColorFromNickname(review.nickname)">
            {{review.nickname.charAt(0)}}
          </div>
          <span class="name font-semibold">{{review.nickname}}</span>
          <span class="date text-small text-nowrap">{{ parseDate(review.created_at) }}</span>
        </div>

        <div class="review-body px-3 mt-4">
          <span class="title font-semibold text-large" v-if="review.title">{{review.title}}</span>

          <span class="title font-semibold text-large" v-else="">{{__('review_levels.' + review.rating)}}</span>

          <div class="d-flex justify-content-start">
            <ReviewsSummary :average_rating="review.rating * 20" :total_reviews="0"/>
          </div>

          <p v-if="review.detail">{{review.detail}}</p>
          <p class="text-grey text-small" v-else >{{__('no_review_comment')}}</p>
        </div>
      </div>

    </div>

  </div>

</template>

<style scoped>

</style>